import { css } from '@linaria/core';

export const list = css`
  list-style: none;
  margin: 0;
  padding: 0;

  & li {
    position: relative;
  }

  & li:not(:last-child)::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: var(--cxy-spacing-4);
    right: var(--cxy-spacing-4);
    border-bottom: var(--cxy-border-default);
  }
`;
